import { ReactComponent as FirstSvg } from 'assets/first.svg';
import { ReactComponent as LastSvg } from 'assets/last.svg';
import { ReactComponent as NextSvg } from 'assets/next.svg';
import { ReactComponent as BackSvg } from 'assets/back.svg';
import usePagination from './hooks/usePagination';
import './styles.scss';

const Pagination = ({ page, setPage, totalPages }) => {
  const {
    paginationControls: { prev, next, goTo, createButtons },
    pagination,
  } = usePagination(page, setPage, totalPages);

  return (
    <div className="pagination">
      <button className="pagination__button" onClick={() => goTo(pagination.minPage)}>
        <FirstSvg />
      </button>
      <button className="pagination__button" onClick={() => prev()}>
        <BackSvg />
      </button>
      {createButtons()}
      <button className="pagination__button" onClick={() => next()}>
        <NextSvg />
      </button>
      <button className="pagination__button" onClick={() => goTo(totalPages)}>
        <LastSvg />
      </button>
    </div>
  );
};

export default Pagination;
